<template>
    <div class="fluid">
        <h1 class="app-title">BOLETOS NÃO ENCONTRADOS EM ARQUIVO DE RETORNO</h1>
        <b-card>
            <b-row class="mb-4">
                <b-col md="2">
                    <label>
                        Data Inicial Boletos:
                    </label>
                    <b-input v-model="filtros.dataInicio" type="date" placeholder></b-input>
                </b-col>
                <b-col md="2">
                    <label>
                        Data Final Boletos:
                    </label>
                    <b-input v-model="filtros.dataFinal" type="date" placeholder></b-input>
                </b-col>
                <b-col md="3">
                    <b-button @click="consultar"
                              style="margin-right: 20px; margin-top: 22px;"
                              variant="primary"
                              class="ml-2">
                        <i class="fa fa-search"></i> Pesquisar
                    </b-button>
                    <b-button @click="exportCSV"
                              style="margin-top: 22px;"
                              variant="primary">
                        <i class="fas fa-file-csv"></i>
                        Exportar CSV
                    </b-button>
                </b-col>
            </b-row>
            <b-row class="d-flex justify-content-between">
                <b-col>
                    <CompBotaoExibirOcultarColuna
                            :fields="fields"
                            :showColunms="showColunms"
                            @toggleColuna="toggleColuna"/>
                </b-col>
                <b-col style="display: flex; justify-content: center;">
                    <b-pagination v-model="configTable.currentPage" :per-page="configTable.perPage"
                                  :total-rows="configTable.rows" size="sm" class="pl-3" style="padding: 0 !important;"
                                  v-if="configTable.perPage != 'Todos'">
                    </b-pagination>
                </b-col>
                <b-col>
                    <b-form-select v-model="configTable.perPage" :options="[10, 100, 500, 1000, 'Todos']" size="sm"
                                   class="mb-3 col-2" style="float:right"></b-form-select>
                    <b-button class="ml-2" variant="secondary" @click="limparFiltros"
                              style="float: right; margin-right: 10px; height: 32px; padding: 0 0.75rem;">
                        <i class="fas fa-broom"></i> Limpar Filtros
                    </b-button>
                </b-col>
            </b-row>
            <TabelaBoletosNaoEncontrados
                    :resultado="items"
                    :fields="fields"
                    :configTable="configTable"
                    :selecteds="selecteds"
                    :filtro="filtros"
                    @openFilterPopup="openFilterPopup"
                    @consultar="consultar"/>
            <b-row class="d-flex justify-content-between" style="margin-top: 10px;">
                <b-col>
                </b-col>
                <b-col style="display: flex; justify-content: center;">
                    <b-pagination v-model="configTable.currentPage" :per-page="configTable.perPage"
                                  :total-rows="configTable.rows" size="sm" class="pl-3" style="padding: 0 !important;"
                                  v-if="configTable.perPage != 'Todos'">
                    </b-pagination>
                </b-col>
                <b-col>
                    <div class="registros-encontrados">
                        <span>Boletos Encontrados</span>
                    </div>
                    <div class="registros-encontrados-valor">
                        <span>{{configTable.perPage != 'Todos' ? configTable.rows : items.length}}</span>
                    </div>

                    <div class="registros-encontrados" style="margin-left: 15px">
                        <span>Boletos Selecionados</span>
                    </div>
                    <div class="registros-encontrados-valor">
                        <span>{{selecteds.length}}</span>
                    </div>
                </b-col>
            </b-row>
        </b-card>
        <CompFiltroGrid
                ref="compFiltro"
                :filtro="filtro"
                @filtrarResultados="filtrarResultados"
                @ordenarResultados="ordenarResultados"/>
        <CompLoading ref="loading"/>
    </div>
</template>
<script>
    import Multiselect from 'vue-multiselect'
    import axios from 'axios'
    import TabelaBoletosNaoEncontrados from "./TabelaBoletosNaoEncontrados";
    import CompBotaoExibirOcultarColuna from "../shared/components/CompBotaoExibirOcultarColuna";
    import CompFiltroGrid from "../shared/components/CompFiltroGrid";
    import CompLoading from "../shared/components/CompLoading";
    import formatarMixins from '../../mixins/formatarMixins';

    export default {
        mixins: [ formatarMixins ],
        components: {CompLoading, CompFiltroGrid, CompBotaoExibirOcultarColuna, TabelaBoletosNaoEncontrados, Multiselect},
        data() {
            return {
                urlApi: null,
                token: null,
                fields: [
                    {
                        key: "selecionar",
                    }
                ],
                items: [],
                configTable: {
                    perPage: 10,
                    lastPage: null,
                    sortField: 'parcela.datahoraemissao',
                    sortOrder: 'desc',
                    currentPage: 1,
                    rows: 0,
                    checkedAll: false,
                    load: false,
                },
                showColunms: [],
                filtro: {
                    tipo: null,
                    campoFiltro: null,
                    filtrarEm: null,
                    mascara: null,
                    campoTexto: null,
                    campoMascara: null,
                    campoData: null,
                    campoRadio: null,
                    campoCheckbox: null,
                    listaValores: []
                },
                filtros: {
                    dataInicio: null,
                    dataFinal: null,
                    numeroRequisicao: null,
                    linhaDigitavel: null,
                    filtrarDataEmissao: null,
                    dataEmissao: null,
                    situacao: null
                },
                selecteds: []
            }
        },
        methods: {
            async exportCSV() {
                this.$store.commit("setMessages", {});

                if(this.filtros.dataInicio != null && this.filtros.dataFinal != null
                    && this.filtros.dataInicio != this.filtros.dataFinal
                    && new Date(this.filtros.dataFinal) < new Date(this.filtros.dataInicio)) {
                    this.exibirMensagem("A Data Inicial Boletos não pode ser maior que a Data Final Boletos.");
                    return;
                }

                if(this.configTable.rows == 0) {
                    this.exibirMensagem("Não há registros a serem exportados.");
                } else {
                    let filtrosPesquisa = {
                        dataInicio: this.filtros.dataInicio,
                        dataFinal: this.filtros.dataFinal,
                        numeroRequisicao: this.filtros.numeroRequisicao,
                        linhaDigitavel: this.filtros.linhaDigitavel,
                        filtrarDataEmissao: this.filtros.filtrarDataEmissao,
                        dataEmissao: this.filtros.dataEmissao,
                        situacao: this.filtros.situacao,
                        selecteds: this.selecteds
                    };

                    this.$refs.loading.showLoading();
                    axios.post(`${this.urlApi}/v1/boletoNaoEncontrado/exportarCsv?sortField=${this.configTable.sortField}&sortOrder=${this.configTable.sortOrder}`, filtrosPesquisa, {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': this.token
                        }
                    }).then(response => {
                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', 'BoletosNaoEncontrados.csv');
                        document.body.appendChild(link);
                        link.click();
                    }).finally(() => {
                        this.$refs.loading.hideLoading();
                    });
                }

            },
            async consultar() {
                this.$store.commit("setMessages", {});

                if(this.filtros.dataInicio != null && this.filtros.dataFinal != null
                        && this.filtros.dataInicio != this.filtros.dataFinal
                        && new Date(this.filtros.dataFinal) < new Date(this.filtros.dataInicio)) {
                    this.exibirMensagem("A Data Inicial Boletos não pode ser maior que a Data Final Boletos.");
                    return;
                }

                let perPageStr = `&perPage=${this.configTable.perPage}`;
                if (this.configTable.perPage === 'Todos') {
                    perPageStr = '';
                    this.configTable.currentPage = 1;
                    this.configTable.rows = 0;
                }

                this.configTable.load = true;
                axios.post(`${this.urlApi}/v1/boletoNaoEncontrado/consultar?page=${this.configTable.currentPage}${perPageStr}&sortField=${this.configTable.sortField}&sortOrder=${this.configTable.sortOrder}`, this.filtros, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': this.token
                    }
                }).then(response => {
                    this.items = response.data.resultado;
                    if (this.configTable.perPage !== 'Todos') {
                        this.configTable.rows = response.data.rows;
                        this.configTable.lastPage = Math.ceil(this.configTable.rows / this.configTable.perPage);
                    } else {
                        this.configTable.lastPage = 1;
                    }
                }).catch((error) => {
                    this.exibirErro(error)
                }).finally(() => {
                    this.configTable.load = false;
                })
            },

            prevPage() {
                this.configTable.currentPage = this.configTable.currentPage - 1;
                this.consultar();
            },

            nextPage() {
                this.configTable.currentPage = this.configTable.currentPage + 1;
                this.consultar();
            },

            async obterColunasUsuario() {
                const funcionalidade = 'boletoNaoEncontrado';

                this.configTable.load = true;
                axios.get(`${this.urlApi}/v1/funcionalidade/configuracao/${funcionalidade}`, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': this.token
                    }
                }).then(response => {
                    response.data.forEach((field, i) => {
                        if (field.ativo) {
                            this.showColunms.push(i + 1)
                        }
                        this.fields.push({
                            key: `${i + 1}`,
                            label: `${field.descricao}`,
                            thClass: field.ativo ? '' : 'd-none', tdClass: field.ativo ? '' : 'd-none',
                            codColunaFuncionalidade: field.codColunaFuncionalidade,
                            codFuncionalidade: field.codFuncionalidade
                        })
                    })
                }).catch((error) => {
                    this.exibirErro(error)
                }).finally(() => {
                    this.configTable.load = false;
                })
            },

            toggleColuna(i) {
                let ativo;
                if (this.showColunms.includes(i)) {
                    this.showColunms.splice(this.showColunms.indexOf(i), 1);
                    this.fields[i].thClass = 'd-none';
                    this.fields[i].tdClass = 'd-none';
                    ativo = false
                } else {
                    this.showColunms.push(i);
                    this.fields[i].thClass = '';
                    this.fields[i].tdClass = '';
                    ativo = true
                }

                this.atualizarConfiguracaoColunm(i, ativo)
            },

            async atualizarConfiguracaoColunm(i, ativo) {
                const json = {
                    codFuncionalidade: this.fields[i].codFuncionalidade,
                    codColunaFuncionalidade: this.fields[i].codColunaFuncionalidade,
                    ativo,
                };
                axios.put(`${this.urlApi}/v1/funcionalidade/configuracao`, json, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': this.token
                    }
                }).catch((error) => {
                    this.exibirErro(error)
                })
            },

            openFilterPopup(campo, tipo, values, mascara, event) {
                if(document.getElementById('popup').style.display == 'block'
                    && this.filtro.campoFiltro == campo) {
                    this.$refs.compFiltro.closeFilterPopup();
                } else {
                    this.filtro.tipo = tipo;
                    this.filtro.campoFiltro = campo;
                    this.filtro.mascara = mascara;
                    if(this.filtro.campoFiltro == 'Número da Requisição') {
                        this.filtro.campoMascara = this.filtros.numeroRequisicao;
                    } else if(this.filtro.campoFiltro == 'Linha Digitável') {
                        this.filtro.campoMascara = this.filtros.linhaDigitavel;
                    } else if(this.filtro.campoFiltro == 'Situação') {
                        this.filtro.campoCheckbox = this.filtros.situacao;
                    } else if(this.filtro.campoFiltro == 'Data Emissão do Boleto') {
                        this.filtro.filtrarEm = this.filtros.filtrarDataEmissao;
                        this.filtro.campoData = this.filtros.dataEmissao;
                    }

                    if(this.filtro.tipo == "checkbox") {
                        this.filtro.listaValores = values;
                    } else if(values != null && values != "") {
                        this.filtro.listaValores = values.split(',');
                    }

                    this.$refs.compFiltro.openCloseFilterPopup(event);
                }
            },
            filtrarResultados(limpar) {
                if(limpar) {
                    this.filtro.filtrarEm = null;
                    this.filtro.campoTexto = null;
                    this.filtro.campoMascara = null;
                    this.filtro.campoData = null;
                    this.filtro.campoRadio = null;
                    this.filtro.campoCheckbox = null;
                }

                if(this.filtro.campoCheckbox != null && !Array.isArray(this.filtro.campoCheckbox)) {
                    this.filtro.campoCheckbox = [this.filtro.campoCheckbox];
                }

                if(this.filtro.campoFiltro == 'Número da Requisição') {
                    this.filtros.numeroRequisicao = this.filtro.campoMascara;
                } else if(this.filtro.campoFiltro == 'Linha Digitável') {
                    this.filtros.linhaDigitavel = this.filtro.campoMascara;
                } else if(this.filtro.campoFiltro == 'Situação') {
                    this.filtros.situacao = this.filtro.campoCheckbox;
                } else if(this.filtro.campoFiltro == 'Data Emissão do Boleto') {
                    this.filtros.filtrarDataEmissao = this.filtro.filtrarEm;
                    this.filtros.dataEmissao = this.filtro.campoData;
                }

                this.configTable.currentPage = 1;

                this.consultar();
            },
            ordenarResultados(order) {
                if(this.filtro.campoFiltro == 'Número da Requisição') {
                    this.configTable.sortField = 'numerorequisicao';
                } else if(this.filtro.campoFiltro == 'Linha Digitável') {
                    this.configTable.sortField = 'parcela.linhadigitavel';
                } else if(this.filtro.campoFiltro == 'Situação') {
                    this.configTable.sortField = 'situacao';
                } else if(this.filtro.campoFiltro == 'Data Emissão do Boleto') {
                    this.configTable.sortField = 'parcela.datahoraemissao';
                }

                this.configTable.sortOrder = order;

                this.consultar();
            },
            limparFiltros() {
                this.filtros = {
                    dataInicio: this.filtros.dataInicio,
                    dataFinal: this.filtros.dataFinal,
                    numeroRequisicao: null,
                    linhaDigitavel: null,
                    filtrarDataEmissao: null,
                    dataEmissao: null,
                    situacao: null
                };

                this.consultar();
            }
        },
        watch: {
            perPage() {
                this.configTable.currentPage = 1;
                this.consultar();
            }
        },
        computed: {
            perPage() {
                return this.configTable.perPage;
            },
        },
        mounted() {
            this.urlApi = process.env.VUE_APP_ROOT_API;
            this.token = JSON.parse(this.$store.getters.getUser).access_token;

            this.$store.commit("setMessages", {});

            var dataAtual = new Date();
            let ano = dataAtual.getFullYear();
            let mes = dataAtual.getMonth() + 1;

            var ultimoDiaMes = new Date(ano, mes, 0);

            this.filtros.dataInicio = ano + "-" + (mes < 10 ? "0" : "") + mes + "-01";
            this.filtros.dataFinal = ano + "-" + (mes < 10 ? "0" : "") + mes + "-" + ultimoDiaMes.getDate();

            this.obterColunasUsuario();
            this.consultar();
        }
    }
</script>
